import queryString from "query-string";

/** Lead page tabs that can be opened from a link, as `/lead/:id?tab=<LeadTab>`. */
export type LeadTab = "search-agent";

const labels: Record<LeadTab, string> = {
	"search-agent": "Search Agent",
};

/** The label of the tab the query string asks for, or undefined when it names none we know. */
export const getLeadTabLabel = (search: string): string | undefined => {
	const { tab } = queryString.parse(search);
	return typeof tab === "string" && Object.prototype.hasOwnProperty.call(labels, tab)
		? labels[tab as LeadTab]
		: undefined;
};

/**
 * The index of the requested tab among the tabs the page is showing. A tab the user cannot see is
 * not in `tabLabels`, so a link to it falls back to the page's default tab.
 */
export const getLeadTabIndex = (search: string, tabLabels: string[]): number | undefined => {
	const label = getLeadTabLabel(search);
	const index = label ? tabLabels.indexOf(label) : -1;
	return index >= 0 ? index : undefined;
};
